<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: HTMLAttributes['class']
  asChild?: boolean
}

defineProps<Props>()
</script>

<template>
  <div
    :class="
      cn(
        'px-3 py-2 text-xs font-medium text-sidebar-foreground/70 uppercase tracking-wider group-data-[collapsible=icon]/sidebar:hidden',
        $props.class
      )
    "
  >
    <slot />
  </div>
</template>
